<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created () {
    if (document.getElementById('Loading')) {
      document.getElementById('Loading').remove()
    }
  }
}
</script>

<style>

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

</style>



// WEBPACK FOOTER //
// src/App.vue